class PredictiveSearch extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('input[type="search"]');
    this.panel = this.querySelector('[data-predictive-results]');
    this.abortController = null;
    this.timer = null;
    this.input?.addEventListener('input', () => {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.search(), 180);
    });
    this.input?.addEventListener('keydown', (event) => { if (event.key === 'Escape') this.close(); });
    document.addEventListener('click', (event) => { if (!this.contains(event.target)) this.close(); });
  }
  async search() {
    const query = this.input.value.trim();
    if (query.length < 2) return this.close();
    this.abortController?.abort();
    this.abortController = new AbortController();
    this.setAttribute('aria-busy', 'true');
    try {
      const url = `${window.Shopify?.routes?.root || '/'}search/suggest?q=${encodeURIComponent(query)}&resources[type]=product,article,page&resources[limit]=6&section_id=predictive-search`;
      const response = await fetch(url, { signal: this.abortController.signal });
      if (!response.ok) throw new Error();
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const results = html.querySelector('[data-predictive-content]');
      this.panel.innerHTML = results?.innerHTML || '';
      this.panel.setAttribute('open', '');
    } catch (error) { if (error.name !== 'AbortError') this.panel.innerHTML = '<p class="predictive-search__results">Search is temporarily unavailable.</p>'; }
    finally { this.removeAttribute('aria-busy'); }
  }
  close() { this.panel?.removeAttribute('open'); }
}
customElements.define('predictive-search', PredictiveSearch);

